import React, { ForwardedRef } from "react";
import TextInput, { NumberTypeProps } from "@atoms/text-input";

const NumberInput = ({ type, value, ...props }: NumberTypeProps, ref: ForwardedRef<HTMLInputElement>) => {
  return <TextInput {...props} ref={ref} value={value} type="number" />;
};

export default React.forwardRef(NumberInput);
